import React from 'react';

var LoadingDots = function LoadingDots() {
  return React.createElement("div", {
    className: "loading-dots"
  }, React.createElement("span", {
    className: "loading-dots__dot"
  }), React.createElement("span", {
    className: "loading-dots__dot"
  }), React.createElement("span", {
    className: "loading-dots__dot"
  }));
};

export { LoadingDots };